// Shared by React and the static generator; no browser imports.
export const canonicalPath = (path, staticSlugs = []) => {
  const clean = '/' + String(path).split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
  if (clean === '/') return '/';
  return staticSlugs.includes(clean.slice(1)) ? clean + '/' : clean;
};

export const pageSchema = (title, url, content) => {
  const graph = [];
  if (url === 'https://calcglobe.com/') {
    graph.push({ '@type': 'WebSite', name: 'CalcGlobe', url });
  } else {
    graph.push({ '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'CalcGlobe', item: 'https://calcglobe.com/' },
      { '@type': 'ListItem', position: 2, name: title.replace(/ \| CalcGlobe$/, ''), item: url },
    ] });
  }
  if (content?.faq?.length) graph.push({ '@type': 'FAQPage', mainEntity: content.faq.map(({ q, a }) => ({
    '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a },
  })) });
  return { '@context': 'https://schema.org', '@graph': graph };
};

export const updatePageHead = (doc, { title, description, url, schema }) => {
  // One owner replaces template tags instead of adding a second React 19 set.
  doc.querySelectorAll('title, meta[name="description"], meta[name="keywords"], link[rel="canonical"], meta[property="og:title"], meta[property="og:description"], meta[property="og:url"], meta[property="og:type"], meta[name="twitter:card"], meta[name="twitter:title"], meta[name="twitter:description"]').forEach(node => node.remove());
  const append = (tag, attrs, text) => {
    const node = doc.createElement(tag);
    Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
    if (text !== undefined) node.textContent = text;
    doc.head.appendChild(node);
  };
  append('title', {}, title);
  append('meta', { name: 'description', content: description });
  append('link', { rel: 'canonical', href: url });
  for (const [property, content] of Object.entries({ 'og:title': title, 'og:description': description, 'og:url': url, 'og:type': 'website' })) append('meta', { property, content });
  for (const [name, content] of Object.entries({ 'twitter:card': 'summary_large_image', 'twitter:title': title, 'twitter:description': description })) append('meta', { name, content });
  // Keep the blog Article schema inside the React subtree; replace legacy
  // template/generated schemas and the previous route's owned graph.
  doc.querySelectorAll('head script[type="application/ld+json"], body > script[type="application/ld+json"], script[data-calcglobe-seo]').forEach(node => node.remove());
  append('script', { type: 'application/ld+json', 'data-calcglobe-seo': 'true' }, JSON.stringify(schema).replace(/</g, '\\u003c'));
};
